(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-both"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__poCardBound) return;
    window.__poCardBound = true;

    function addUrl() {
      return (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add';
    }

    async function addVariants(button) {
      var ids = (button.getAttribute('data-variants') || '')
        .split(',')
        .map(function (s) { return s.trim(); })
        .filter(Boolean);
      if (!ids.length) return;

      button.setAttribute('data-loading', 'true');
      try {
        var res = await fetch(addUrl() + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) }),
        });
        if (!res.ok) {
          var err = await res.json().catch(function () { return {}; });
          throw new Error(err.description || err.message || 'cart_add_failed');
        }

        var cart = await fetch('/cart.js').then(function (r) { return r.json(); }).catch(function () { return null; });

        var evt = new Event('cart:update', { bubbles: true });
        evt.detail = {
          resource: cart,
          sourceId: 'po-card',
          data: { source: 'po-card', itemCount: cart ? cart.item_count : ids.length },
        };
        document.dispatchEvent(evt);

        var drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        } else {
          window.location.href =
            (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart';
        }
      } catch (err) {
        console.error('[po-card]', err);
        var msg = button.getAttribute('data-error-text');
        if (msg) window.alert(msg);
      } finally {
        button.removeAttribute('data-loading');
      }
    }

    function selectOption(opt) {
      var card = opt.closest('.po-card');
      if (!card) return;

      card.querySelectorAll('.po-card__opt').forEach(function (o) {
        var on = o === opt;
        o.classList.toggle('is-selected', on);
        var input = o.querySelector('.po-card__input');
        if (input) input.checked = on;
      });

      // Sync every CTA (in-card and the floating sticky bar) with the selection.
      var variants = opt.getAttribute('data-variants') || '';
      var price = opt.getAttribute('data-price');
      document.querySelectorAll('.po-card__cta').forEach(function (cta) {
        cta.setAttribute('data-variants', variants);
        var priceEl = cta.querySelector('.po-card__cta-price');
        if (priceEl && price) priceEl.textContent = price;
      });
    }

    // Floating sticky add-to-cart: slides up once the main card scrolls out of view.
    function initSticky() {
      var sticky = document.querySelector('.po-sticky');
      var card = document.querySelector('.po-card');
      if (!sticky || !card) return;
      // Move to <body> so position:fixed is always viewport-relative.
      if (sticky.parentElement !== document.body) document.body.appendChild(sticky);

      var anchor = card.querySelector('.po-card__cta');
      if (!anchor || !('IntersectionObserver' in window)) return;

      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            // Show only after scrolling PAST the card (card above the viewport).
            sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
          });
        },
        { threshold: 0 }
      ).observe(anchor);
    }

    if (document.readyState !== 'loading') initSticky();
    else document.addEventListener('DOMContentLoaded', initSticky);

    document.addEventListener('click', function (event) {
      var opt = event.target.closest('.po-card__opt');
      if (opt) {
        selectOption(opt);
        return;
      }
      var cta = event.target.closest('.po-card__cta');
      if (cta && !cta.disabled && cta.getAttribute('data-loading') !== 'true') {
        event.preventDefault();
        addVariants(cta);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["combo-duo"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__comboDuoBound) return;
    window.__comboDuoBound = true;

    function route(key, fallback) {
      return (window.Theme && window.Theme.routes && window.Theme.routes[key]) || fallback;
    }

    async function addCombo(button) {
      var ids = (button.getAttribute('data-variants') || '')
        .split(',')
        .map(function (s) { return s.trim(); })
        .filter(Boolean);
      if (!ids.length) return;

      button.setAttribute('data-loading', 'true');
      try {
        var res = await fetch(route('cart_add_url', '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) }),
        });
        if (!res.ok) {
          var err = await res.json().catch(function () { return {}; });
          throw new Error(err.description || err.message || 'cart_add_failed');
        }

        var cart = await fetch('/cart.js').then(function (r) { return r.json(); }).catch(function () { return null; });

        var evt = new Event('cart:update', { bubbles: true });
        evt.detail = {
          resource: cart,
          sourceId: 'combo-duo',
          data: { source: 'combo-duo', itemCount: cart ? cart.item_count : ids.length },
        };
        document.dispatchEvent(evt);

        var drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        } else {
          window.location.href = route('cart_url', '/cart');
        }
      } catch (err) {
        console.error('[combo-duo]', err);
        var msg = button.getAttribute('data-error-text');
        if (msg) window.alert(msg);
      } finally {
        button.removeAttribute('data-loading');
      }
    }

    document.addEventListener('click', function (event) {
      var cta = event.target.closest('.cd-cta');
      if (cta && !cta.disabled && cta.getAttribute('data-loading') !== 'true') {
        event.preventDefault();
        addCombo(cta);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["kit-packs"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__kitPacksBound) return;
    window.__kitPacksBound = true;

    function route(key, fallback) {
      return (window.Theme && window.Theme.routes && window.Theme.routes[key]) || fallback;
    }

    function selectedOption(card) {
      return card ? card.querySelector('.kp-opt.is-selected:not(.is-unavailable)') : null;
    }

    async function addSelected(button) {
      var card = document.querySelector('.kp-card');
      var opt = selectedOption(card);

      // Sin filas de opciones (fichas de kit: el pack es fijo) el botón lleva
      // la variante del propio producto.
      var source = opt || button;
      var id = Number(source.getAttribute('data-variant'));
      var qty = Number(source.getAttribute('data-qty')) || 1;
      if (!id) return;

      var goToCheckout = button.getAttribute('data-checkout') === 'true';

      button.setAttribute('data-loading', 'true');
      try {
        var res = await fetch(route('cart_add_url', '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: qty }] }),
        });
        if (!res.ok) {
          var err = await res.json().catch(function () { return {}; });
          throw new Error(err.description || err.message || 'cart_add_failed');
        }

        if (goToCheckout) {
          window.location.href = '/checkout';
          return;
        }

        var cart = await fetch('/cart.js').then(function (r) { return r.json(); }).catch(function () { return null; });

        var evt = new Event('cart:update', { bubbles: true });
        evt.detail = {
          resource: cart,
          sourceId: 'kit-packs',
          data: { source: 'kit-packs', itemCount: cart ? cart.item_count : qty },
        };
        document.dispatchEvent(evt);

        var drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        } else {
          window.location.href = route('cart_url', '/cart');
        }
      } catch (err) {
        console.error('[kit-packs]', err);
        var msg = button.getAttribute('data-error-text');
        if (msg) window.alert(msg);
      } finally {
        button.removeAttribute('data-loading');
      }
    }

    function selectOption(opt) {
      if (opt.classList.contains('is-unavailable')) return;

      var card = opt.closest('.kp-card');
      if (!card) return;

      card.querySelectorAll('.kp-opt').forEach(function (o) {
        var on = o === opt;
        o.classList.toggle('is-selected', on);
        var input = o.querySelector('.kp-input');
        if (input && !input.disabled) input.checked = on;
      });

      // Sincroniza el precio mostrado en los CTA (incluido el sticky).
      var price = opt.getAttribute('data-price');
      document.querySelectorAll('.kp-cta-price').forEach(function (el) {
        if (price) el.textContent = price;
      });
    }

    function syncInitialPrice() {
      var card = document.querySelector('.kp-card');
      var opt = selectedOption(card);
      if (!opt) return;
      var price = opt.getAttribute('data-price');
      document.querySelectorAll('.kp-cta-price').forEach(function (el) {
        if (price) el.textContent = price;
      });
    }

    function initSticky() {
      var sticky = document.querySelector('.kp-sticky');
      var card = document.querySelector('.kp-card');
      if (!card) return;
      syncInitialPrice();
      if (!sticky) return;

      // Se mueve a <body> para que position:fixed sea relativo al viewport.
      if (sticky.parentElement !== document.body) document.body.appendChild(sticky);

      var anchor = card.querySelector('.kp-actions');
      if (!anchor || !('IntersectionObserver' in window)) return;

      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
          });
        },
        { threshold: 0 }
      ).observe(anchor);
    }

    if (document.readyState !== 'loading') initSticky();
    else document.addEventListener('DOMContentLoaded', initSticky);

    document.addEventListener('click', function (event) {
      var opt = event.target.closest('.kp-opt');
      if (opt) {
        event.preventDefault();
        selectOption(opt);
        return;
      }
      var cta = event.target.closest('.kp-cta');
      if (cta && !cta.disabled && cta.getAttribute('data-loading') !== 'true') {
        event.preventDefault();
        addSelected(cta);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
